<template>
    <section class="textSection">
        <h1>Les ateliers présentiels - Du numérique à la vraie vie</h1>
        <p>
            Savoir Être Aidant est une formation gratuite et ouverte à tous dont l’objectif est de permettre à vous, aidants, d'appréhender votre rôle avec plus de sérénité.
        </p>
        <p>            
            C’est pourquoi nous vous proposons, en parallèle des vidéos de formations, des ateliers présentiels qui débuteront en octobre 2017 et qui se poursuivront tout au long de l’année 2018 sur le territoire de la Seine-Amont (Ivry-sur-Seine, Vitry-sur-Seine, Choisy-le-Roi).
        </p>
        <p>            
            Pour participer gratuitement à ces ateliers de formation, il suffit de vous inscrire en nous contactant soit sur <a href="mailto:contact@savoiretreaidant.fr">contact@savoiretreaidant.fr</a> ou en ou appelant au 07.67.42.33.91.
        </p>
        <p>            
            Retrouvez l’ensemble du programme de formation présentielle ci-dessous :
        </p>
        <!-- <p>Planning des futurs évènements organisés autour de la formation <em>Savoir Être Aidant</em></p>
        <article v-for="(event, index) in events" :key="index" class="eventArticle">
            <h2>{{event.title}} <small> {{event.date | formatDate}} à {{event.date | formatHour}}</small></h2>
            <h3>{{event.tag}}</h3>
            <vue-markdown>{{event.content}}</vue-markdown>
        </article> -->
        <img src="/static/img/workshops_2019.png" class="workshops-image" />
    </section>
</template>

<script>
    //https://simplemde.com/markdown-guide
    import VueMarkdown from 'vue-markdown'
    import moment from 'moment'
    import EventService from '../services/events.js'
    
    export default {
        name: 'event-List',
    data: function () {
      return {
        events: null,
      }
    },
    components: {
            VueMarkdown
        },
    created: function () {
      this.getEventsList()
    },
    methods: {
        getEventsList: function () {
            EventService.get().then((res) => {
            console.log('EventService.get.then', this, res)
            this.events = res.body
            }, (res) => {
            console.warn(res)
            })
        },
        }
    }
</script>

<style>
.eventArticle
{
    width:45%;
    margin-left:0px;
    padding: 10px 0px;
    border-right:#662483 1px solid;
}
.eventArticle small
{
    margin-left:10px;
}
.eventArticle img
{
    float:left;
    margin:5px;
}

.workshops-image {
    display: block;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// Events.vue?13b6548e